import { generateAesGcmKey } from '@lucidlink/ts-crypto/crypto';
import { wrapKeyWithAesKey, wrapKeyWithPassword } from '#sdk/common';
export const preparePasswordUserCrypto = async (password) => {
    const cryptoKey = await generateAesGcmKey();
    const wrappedKeyData = await wrapKeyWithPassword(password, cryptoKey);
    return { cryptoKey, ...wrappedKeyData };
};
export const prepareSsoUserCrypto = async (domainSecret) => {
    const cryptoKey = await generateAesGcmKey();
    return prepareSsoUserCryptoWithExistingKey(domainSecret, cryptoKey);
};
export const prepareSsoUserCryptoWithExistingKey = async (domainSecret, cryptoKey) => {
    const wrappedKeyData = await wrapKeyWithAesKey(domainSecret, cryptoKey);
    return { cryptoKey, ...wrappedKeyData };
};
